/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: wboCjrKjkicgLwUG7d8r4V

import { createUseStyleTokens } from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: wboCjrKjkicgLwUG7d8r4V/projectModule

const data = {
  base: `${"plasmic_tokens_wboCjrKjkicgLwUG7d8r4V"} ${"plasmic_tokens_ohDidvG9XsCeFumugENU3J"}`,
  varianted: []
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);
